var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('appHeader',{attrs:{"userInfo":_vm.userInfo}}),_c('router-view',{on:{"user":_vm.getUserInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }